import { useState } from 'react';
import { submitReaddyForm, type FormResult } from '@/lib/form';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/dalqv0b8bfvm9eaivsmg';

const TOPICS = ['内容纠错与建议', '选题投稿', '栏目合作', '其他咨询'];

export default function ContactForm() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'done'>('idle');
  const [result, setResult] = useState<FormResult | null>(null);

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    setStatus('loading');
    const res = await submitReaddyForm(form, SUBMIT_ADDR, '已收到你的留言，我们会尽快回复。');
    setResult(res);
    setStatus('done');
    if (res.ok) form.reset();
  };

  const fieldClass =
    'w-full h-11 px-4 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all';

  return (
    <form
      id="contact-inquiry"
      data-readdy-form
      action={SUBMIT_ADDR}
      method="post"
      onSubmit={onSubmit}
      className="space-y-5"
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label htmlFor="contact-name" className="block text-sm text-foreground-700 mb-2">
            怎么称呼你
          </label>
          <input
            id="contact-name"
            type="text"
            name="name"
            required
            placeholder="你的昵称"
            className={fieldClass}
          />
        </div>
        <div>
          <label htmlFor="contact-email" className="block text-sm text-foreground-700 mb-2">
            联系邮箱
          </label>
          <input
            id="contact-email"
            type="email"
            name="email"
            required
            placeholder="name@example.com"
            className={fieldClass}
          />
        </div>
      </div>

      <div>
        <label htmlFor="contact-topic" className="block text-sm text-foreground-700 mb-2">
          咨询类型
        </label>
        <select id="contact-topic" name="topic" className={`${fieldClass} pr-10`} defaultValue={TOPICS[0]}>
          {TOPICS.map((t) => (
            <option key={t} value={t}>
              {t}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label htmlFor="contact-message" className="block text-sm text-foreground-700 mb-2">
          想说的话
        </label>
        <textarea
          id="contact-message"
          name="message"
          required
          maxLength={500}
          rows={5}
          placeholder="请简单描述你的问题或建议（500 字以内）"
          className="w-full px-4 py-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
        />
      </div>

      <input
        className="alt-field"
        type="text"
        name="company_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />

      <button
        type="submit"
        disabled={status === 'loading'}
        className="h-12 px-8 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed"
      >
        {status === 'loading' ? '发送中…' : '提交留言'}
      </button>

      {status === 'done' && result && (
        <p
          role="status"
          className={`text-sm ${result.ok ? 'text-accent-700' : 'text-primary-700'}`}
        >
          {result.message}
        </p>
      )}
    </form>
  );
}